// Enhancements tell you more about the request so you can quickly debug what might be going wrong

export {
  ConsoleAST,
  ArgumentSpan
} from './enhancements/console';

export {

  // Enhancement Names: 'console', 'context', ... 
  EnhancementName,
  EnhancementType,


  // Events
  EnhancementConsoleTimelineEvent,
  EnhancemnetErrorTimelineEvent,
  EnhancementEvent,


  // Values
  EnhancementContextValue,
  EnhancementValue,


  // Enablement
  EnablementError,

  // If we enabled console at what level
  EnhancementConsoleEnablementSuccess,
  EnhancementConsoleEnablementFailure,
  EnhancementConsoleEnablement,


  // If we enabled context
  EnhancementContextEnablementSuccess,
  EnhancementContextEnablementFailure,
  EnhancementContextEnablement,

  DetailedEnhancementEnablement,
  EnhancementEnablement,

  // Parse out & create the detailed values
  detailedEnablements,

  // Result 
  EnhancementSuccess,
  EnhancementFailure,
  EnhancementResult,

} from './enhancements';


export {
  IEnhancementToken,
  EnhancementHostConfigType,
  IEnhancementHostConfigRegex,
  IEnhancementHostConfigExact,
  IEnhancementHostConfig,
  IEnhancementConfig,
  IEnhancementRecord,
} from './config';

export {
  LogLevel,
  LogLevelEmergency,
  LogLevelAlert,
  LogLevelCritical,
  LogLevelError,
  LogLevelWarning,
  LogLevelNotice,
  LogLevelInformational,
  LogLevelDebug,
} from './logging';

export {
  EnhancementStatus
} from './result';

export {
  ISerializedValue,
  ValueType,
  NativeType,
  SerializationStrategy,
} from './serialization';
